import { render, staticRenderFns } from "./StaticBiggestSell.vue?vue&type=template&id=02cf5987"
import script from "./StaticBiggestSell.vue?vue&type=script&lang=js"
export * from "./StaticBiggestSell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports